var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.383,
    height: 18.383,
    viewBox: "0 0 18.383 18.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65882",
    "data-name": "Path 65882",
    d: "M3.575,11.858a.375.375,0,0,1-.375-.375V3.575A.375.375,0,0,1,3.575,3.2H9.4a.375.375,0,0,1,.375.375v7.909a.375.375,0,0,1-.375.375Zm0,8.325a.375.375,0,0,1-.375-.375V16.062a.375.375,0,0,1,.375-.375H9.4a.375.375,0,0,1,.375.375v3.746a.375.375,0,0,1-.375.375Zm10.406,0a.375.375,0,0,1-.375-.375V11.9a.375.375,0,0,1,.375-.375h5.827a.375.375,0,0,1,.375.375v7.909a.375.375,0,0,1-.375.375ZM13.606,3.575a.375.375,0,0,1,.375-.375h5.827a.375.375,0,0,1,.375.375V7.321a.375.375,0,0,1-.375.375H13.981a.375.375,0,0,1-.375-.375Z",
    transform: "translate(-2.5 -2.5)",
    fill: "none",
    stroke: "#4b74be",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/DashboardActive.591bca38f5685d9e3d2bd03bfd4b5c16.svg";
export { ForwardRef as ReactComponent };